import React, { useEffect, useState } from "react";
import API from "../config/API";
import { useAuth } from "../AuthContext";
import { v4 as uuidv4 } from "uuid";

const LeftSidebar = ({
  selectedReport,
  setSelectedReport,
  reports,
  selectedReportMessages,
  setSelectedReportMessages,
  selectedReportFiles,
  setSelectedReportFiles,
  pendingReport,
  setPendingReport,
  isLoadingLeftSidebar,
  setIsLoadingLeftSidebar,
  refreshReportsList,
  editingReportId,
  setEditingReportId,
  titleInput,
  setTitleInput,
  setReports,
  userId,
  searchQuery,
  setSearchQuery,
  isCollapsed,
  toggleCollapse,
  setJustSwitchedReport,
  showSnackbar,
  isLoading,
  setIsLoading,
  buttonStyle,
  spinnerStyle,
  genericColor,
  input,
  setInput,
}) => {
  const handleClickReport = async (obj) => {
    if (isLoading == true) {
      return false;
    }
    setPendingReport(false);
    setSelectedReport(obj);
    setJustSwitchedReport(true);
    setInput("");
  };

  const handleSearchReport = async (query) => {
    setSearchQuery(query); // track it

    if (query.trim() === "") {
      refreshReportsList();
      return;
    }

    try {
      setIsLoadingLeftSidebar(true);
      const res = await API.get(
        `/reports/${userId}/search?q=${encodeURIComponent(query)}`,
      );
      setReports(res.data.reports);
    } catch (err) {
      console.error("Search failed:", err);
    } finally {
      setIsLoadingLeftSidebar(false);
    }
  };

  const handleRenameReport = async (reportId, newTitle) => {
    try {
      await API.post(`/reports/${reportId}`, { title: newTitle });
      if (searchQuery.trim() !== "") {
        await handleSearchReport(searchQuery);
      } else {
        await refreshReportsList();
      }
      setEditingReportId(null);
      showSnackbar("Report renamed", "success");
    } catch (err) {
      console.error("Failed to rename Report:", err);
    }
  };

  const handleDeleteReport = async (reportId) => {
    if (!window.confirm("Delete this Report?")) return;

    try {
      await API.delete(`/reports/${reportId}`);
      setSelectedReport(null);
      setSelectedReportMessages([]);
      setPendingReport(false);
      // Ideally refresh the Report list instead of reloading the page
      //await refreshReportsList();
      showSnackbar("Report deleted", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (err) {
      console.error("Failed to delete Report:", err);
    }
  };

  const handleNewReport = () => {
    const newConvId = uuidv4();
    const tempReport = {
      report_id: newConvId,
      title: "",
      pending: true,
    };

    setSelectedReport(tempReport);
    setSelectedReportMessages([]);
    setSelectedReportFiles([]);
    setPendingReport(true);
    setInput("");
  };

  return (
    <div
      className="sidebar-left grey lighten-4"
      style={{
        width: isCollapsed ? "60px" : "400px",
        padding: isCollapsed ? "10px" : "20px",
        height: "100vh",
        borderRight: "1px solid #ccc",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ marginBottom: "20px", alignSelf: "flex-start" }}>
        <button className="btn-flat" onClick={toggleCollapse} title="Collapse">
          <i className="material-icons">
            {isCollapsed ? "chevron_right" : "chevron_left"}
          </i>
        </button>
      </div>

      {!isCollapsed && (
        <>
          <div
            style={{
              marginBottom: "30px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <a
              style={buttonStyle}
              className="btn waves-effect waves-light"
              href="#!"
              onClick={handleNewReport}
              disabled={isLoading}
            >
              New Report
            </a>
          </div>

          <div style={{ marginBottom: "20px", width: "100%" }}>
            <input
              type="text"
              placeholder="Search Reports..."
              className="browser-default"
              style={{
                width: "100%",
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
              value={searchQuery}
              onChange={(e) => {
                const value = e.target.value;
                handleSearchReport(value);
              }}
            />
          </div>

          {isLoadingLeftSidebar ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "30px",
              }}
            >
              <div className="preloader-wrapper active">
                <div className="spinner-layer spinner-teal-only">
                  <div className="circle-clipper left">
                    <div className="circle" style={spinnerStyle}></div>
                  </div>
                  <div className="gap-patch">
                    <div className="circle" style={spinnerStyle}></div>
                  </div>
                  <div className="circle-clipper right">
                    <div className="circle" style={spinnerStyle}></div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <ul
              className="collection"
              style={{ width: "100%", border: "none" }}
            >
              {Array.isArray(reports) &&
                reports.map((c) => (
                  <li
                    key={c._id}
                    className="collection-item"
                    style={{
                      marginBottom: "10px",
                      borderRadius: "10px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      color:
                        selectedReport?.report_id === c.report_id
                          ? "white"
                          : "black",
                      backgroundColor:
                        selectedReport?.report_id === c.report_id
                          ? localStorage.getItem("userMainColor")
                          : "white",
                      cursor: "pointer",
                    }}
                  >
                    {editingReportId === c.report_id ? (
                      <input
                        autoFocus
                        value={titleInput}
                        onChange={(e) => setTitleInput(e.target.value)}
                        onBlur={() =>
                          handleRenameReport(c.report_id, titleInput)
                        }
                        style={{
                          flexGrow: 1,
                          fontSize: "1rem",
                          padding: "2px 6px",
                        }}
                      />
                    ) : (
                      <span
                        onClick={() => handleClickReport(c)}
                        style={{ flexGrow: 1 }}
                      >
                        {c.title.length > 30
                          ? `${c.title.slice(0, 30)}...`
                          : c.title}
                      </span>
                    )}
                    <span
                      style={{ marginRight: "10px", cursor: "pointer" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (editingReportId === c.report_id) {
                          setEditingReportId(null);
                        } else {
                          setEditingReportId(c.report_id);
                          setTitleInput(c.title || "");
                        }
                      }}
                    >
                      ✎
                    </span>
                    <span
                      style={{
                        color:
                          selectedReport?.report_id === c.report_id
                            ? "white"
                            : genericColor,
                        cursor: "pointer",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteReport(c.report_id);
                      }}
                    >
                      &times;
                    </span>
                  </li>
                ))}
            </ul>
          )}
        </>
      )}
    </div>
  );
};

export default LeftSidebar;
